import { memo } from 'react';

import {
  GeneralLibraryMember,
  type GeneralLibraryMemberProps,
} from '~/components/LibraryBeta/GeneralLibrarySettingsModal/components/GeneralLibraryMembers/GeneralLibraryMember';

type GeneralLibraryMembersListProps = {
  members: GeneralLibraryMemberProps['member'][];
};

export const GeneralLibraryMembersList = memo(({ members }: GeneralLibraryMembersListProps) => (
  <ul className="flex flex-col gap-4">
    {members.map((member) => (
      <GeneralLibraryMember key={member.accountId} member={member} />
    ))}
  </ul>
));

GeneralLibraryMembersList.displayName = 'GeneralLibraryMembersList';
